import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { RoomShoppable } from '@pages/shop/homes/[home]/home';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import makeStyles from '@ui/utils/makeStyles';
import _shortAddress from '@ui/utils/shortAddress';
import React from 'react';

import ShoppableRoom from './ShoppableRoom';

type ShoppableRoomsProps = {
  home?: guesthouse.Home;
  pseudoRooms: RoomShoppable[];
  loading?: boolean;
}

const useStyles = makeStyles()((theme) => ({
  contentBlock: {
    display: 'flex',
  },
  roomWrapper: {
    flex: 1,
    [theme.breakpoints.up('md')]: {
      order: 1,
      marginTop: theme.spacing(3),
    },
  },
}));

const ShoppableRooms: React.FC<ShoppableRoomsProps> = (props) => {
  const { home, pseudoRooms, loading } = props;
  const { theme, classes } = useStyles();
  const { md } = useBreakpoints();

  const homeShortAddress = _shortAddress(home.address);

  if (loading) {
    return (
      <Box className={classes.roomWrapper}>
        <Grid
          container
          spacing={.5}
        >
          {new Array(8).fill(0).map((_, i) => (
            <Grid
              key={i}
              item
              xs={6}
              lg={4}
              xl={3}
            >
              <Skeleton
                variant="rectangular"
                width="100%"
                height={292}
                style={{
                  padding: theme.spacing(0, 4),
                  marginBottom: theme.spacing(1),
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <div className={classes.roomWrapper} >
      <Typography
        component="div"
        variant="h3"
        style={{ 
          marginLeft: md ? 0 : theme.spacing(3)
        }}
      >
        {homeShortAddress}
      </Typography>
      {pseudoRooms.map((pseudoRoom: RoomShoppable, i) => {
        if (!pseudoRoom.productCount) {
          return null;
        }

        if (!md && !pseudoRoom?.docID) {
          return;
        }

        return (
          <ShoppableRoom
            key={`${pseudoRoom.roomDocID}_${i}`}
            pseudoRoom={pseudoRoom}
          />
        );
      })
      }
    </div>
  );
};

export default React.memo(ShoppableRooms);
